 import React from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import SecondNavbar from "../components/SecondNavbar";
import Footer from "../components/Footer";
import "./Awarness.css";

function Awareness() {
  const topics = [
    { name: "Air Awareness", path: "/Awareness/air", desc: "Monitor smog, AQI data, and urban air quality solutions.", tag: "Critical", glowClass: "glow-air" },
    { name: "Water Awareness", path: "/Awareness/water", desc: "Conservation strategies, clean water access, and pollution control.", tag: "Vital Resource", glowClass: "glow-water" },
    { name: "Plant Awareness", path: "/Awareness/plant", desc: "Native flora, urban forestry, and green architecture.", tag: "Reforestation", glowClass: "glow-plant" },
    { name: "Birds Protection", path: "/Awareness/birds", desc: "Safeguarding migratory paths and urban bird habitats.", tag: "Biodiversity", glowClass: "glow-birds" },
    { name: "Animal Safety", path: "/Awareness/animal", desc: "Protecting wildlife and preventing habitat loss.", tag: "Wildlife Care", glowClass: "glow-animal" },
    { name: "Sunlight & Energy", path: "/Awareness/sunlight", desc: "Harnessing renewable solar energy for sustainable living.", tag: "Clean Energy", glowClass: "glow-sun" },
  ];

  return (
    <div className="awareness-wrapper">
      <Navbar />
      <SecondNavbar />

      <main className="awareness-page">
        <section className="awareness-hero">
          <div className="hero-shape-overlay"></div>
          <motion.div 
            initial={{ opacity: 0, scale: 0.95, y: -20 }} 
            animate={{ opacity: 1, scale: 1, y: 0 }} 
            transition={{ duration: 0.8 }}
            className="hero-content-box"
          >
            <div className="hero-badge-pill">
              <span className="pulse-dot"></span> ECOVIBE RESEARCH PORTAL
            </div>
            <h1>Global Environmental <br /><span>Awareness Hub</span></h1>
            <p>
              Advancing ecosystem preservation through real-time data tracking, 
              community action frameworks, and scientific research modules.
            </p>
            <div className="hero-actions">
              <NavLink to="/volunteer" className="hero-btn-primary">Join The Mission</NavLink>
              <a href="#domains-grid" className="hero-btn-secondary">Explore Modules <span>&darr;</span></a>
            </div>
          </motion.div>
        </section>

        <section id="domains-grid" className="topics-section">
          <div className="section-title-box">
            <span className="sub-tag">RESEARCH DOMAINS</span>
            <h2>Explore Ecological Modules</h2>
            <p>Select a specialized domain to analyze environmental metrics, impact factors, and local strategies.</p>
          </div>
          
          <div className="awareness-grid">
            {topics.map((topic, index) => (
              <motion.div 
                key={index} 
                whileHover={{ y: -10 }} 
                transition={{ duration: 0.3, ease: "easeOut" }}
              >
                <NavLink to={topic.path} className={`awareness-card ${topic.glowClass}`}>
                  <div className="card-top-row">
                    <span className="card-pill-tag">{topic.tag}</span>
                  </div>
                  
                  <div className="card-body">
                    <h3>{topic.name}</h3>
                    <p>{topic.desc}</p>
                  </div>

                  <div className="card-bottom-row">
                    <span className="access-text">Access Module</span>
                    <div className="arrow-circle">&rarr;</div>
                  </div>
                </NavLink>
              </motion.div>
            ))}
          </div>
        </section>

        <section className="impact-section">
          <div className="impact-container">
            <div className="impact-card">
              <div className="impact-number">120+</div>
              <div className="impact-label">Pollution & Air Reports Logged</div>
            </div>
            <div className="impact-card">
              <div className="impact-number">500+</div>
              <div className="impact-label">Hectares of Canopy Protected</div>
            </div>
            <div className="impact-card">
              <div className="impact-number">80+</div>
              <div className="impact-label">Wildlife Habitats Secured</div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Awareness;